export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7239.f1fbbe3a.jpg";